package xyz.malefic.multipage.i18n

enum class Language { JA, EN }

object Strings {
    fun get(key: String, lang: Language): String =
        when (lang) {
            Language.JA -> ja[key] ?: key
            Language.EN -> en[key] ?: key
        }

    private val ja = mapOf(
        // Brand
        "brand.name" to "LivStayJapan",
        "brand.tagline" to "空き家・不動産の最適活用をご支援します",

        // Navigation
        "nav.home" to "ホーム",
        "nav.services" to "サービス",
        "nav.about" to "会社概要",
        "nav.contact" to "お問い合わせ",
        "nav.consultation" to "無料相談",

        // Hero section
        "hero.title" to "最適な活用を\nお客様にご提案します",
        "hero.subtitle" to "空き家管理、資産整理サポート、不動産活用、片付け支援、\n相続コンサルタント、見守りサービス、売買賃貸など\nどんな小さなお悩みでも、お気軽にご相談ください。",
        "hero.cta" to "お問い合わせはこちら",

        // Problem section
        "problem.title" to "こんなお悩みありませんか？",
        "problem.subtitle" to "一人で抱え込まず、まずはご相談ください",
        "problem.1" to "突然の相続で、どこから手をつけていいかわからない",
        "problem.2" to "遠方に住んでいて、空き家の管理ができない",
        "problem.3" to "故人の遺品の整理に精神的な負担を感じている",
        "problem.4" to "手続きや届出が多く、何をすべきかわからない",

        // Services overview
        "services.title" to "サービス内容",
        "services.subtitle" to "空き家管理から不動産活用まで、幅広くご支援いたします",
        "services.ihinseiri.title" to "空き家の管理",
        "services.ihinseiri.desc" to "無理のない価格で維持、管理するサービスです。",
        "services.akiya.title" to "不動産活用",
        "services.akiya.desc" to "お客様の状況に寄り添ったコンサルティング。",
        "services.zaimu.title" to "相続・資産整理サポート",
        "services.zaimu.desc" to "相続や資産管理の手続き、整理を丁寧にご案内します。",
        "services.tokushu.title" to "片付け支援",
        "services.tokushu.desc" to "不用品の整理から部屋の片付けまで、丁寧にサポートいたします。",

        // Services detail page
        "services.page.title" to "サービス詳細",
        "services.page.subtitle" to "お客様のご状況に合わせた最適なプランをご提案いたします",

        "services.ihinseiri.detail" to "故人様のお部屋の片付けから清掃まで、一貫して対応いたします。思い出の品は丁寧に仕分け、ご遺族にお渡しいたします。不用品の処分・リサイクルも承ります。",
        "services.ihinseiri.f1" to "お部屋の片付け・仕分け",
        "services.ihinseiri.f2" to "思い出の品の整理・保管",
        "services.ihinseiri.f3" to "不用品の処分・リサイクル",
        "services.ihinseiri.f4" to "清掃・原状回復",

        "services.akiya.detail" to "相続した空き家を放置すると、建物の劣化や近隣トラブルの原因になります。定期的な巡回と管理で、大切な資産をお守りします。",
        "services.akiya.f1" to "定期巡回・目視点検",
        "services.akiya.f2" to "換気・通水作業",
        "services.akiya.f3" to "郵便物の転送・管理",
        "services.akiya.f4" to "簡易清掃・草刈り",

        "services.zaimu.detail" to "相続に伴う各種届出や手続きは多岐にわたります。提携する専門家（税理士・司法書士・弁護士）と連携し、トータルでサポートいたします。",
        "services.zaimu.f1" to "相続届出のサポート",
        "services.zaimu.f2" to "各種名義変更の手続き",
        "services.zaimu.f3" to "専門家（税理士等）へのご紹介",
        "services.zaimu.f4" to "不動産の査定・売却サポート",

        "services.tokushu.detail" to "孤独死や長期間放置されたお部屋など、特殊な状況にも対応いたします。専門の資格を持ったスタッフが、安全かつ迅速に作業を行います。",
        "services.tokushu.f1" to "特殊清掃・消臭作業",
        "services.tokushu.f2" to "害虫駆除",
        "services.tokushu.f3" to "原状回復工事",
        "services.tokushu.f4" to "ご供養の手配",

        // Pricing
        "pricing.title" to "料金プラン",
        "pricing.subtitle" to "明瞭な料金体系で安心してご依頼いただけます",
        "pricing.recommended" to "おすすめ",
        "pricing.basic.name" to "ベーシック",
        "pricing.basic.price" to "¥30,000〜",
        "pricing.basic.desc" to "1K〜1DKの遺品整理",
        "pricing.basic.f1" to "仕分け・片付け",
        "pricing.basic.f2" to "不用品処分",
        "pricing.basic.f3" to "簡易清掃",
        "pricing.standard.name" to "スタンダード",
        "pricing.standard.price" to "¥80,000〜",
        "pricing.standard.desc" to "2DK〜3LDKの遺品整理",
        "pricing.standard.f1" to "仕分け・片付け",
        "pricing.standard.f2" to "不用品処分",
        "pricing.standard.f3" to "清掃・消臭",
        "pricing.standard.f4" to "思い出の品の整理",
        "pricing.premium.name" to "プレミアム",
        "pricing.premium.price" to "¥150,000〜",
        "pricing.premium.desc" to "一戸建て・大型物件の遺品整理",
        "pricing.premium.f1" to "仕分け・片付け",
        "pricing.premium.f2" to "不用品処分",
        "pricing.premium.f3" to "清掃・消臭・原状回復",
        "pricing.premium.f4" to "思い出の品の整理",
        "pricing.premium.f5" to "各種届出サポート",
        "pricing.note" to "※料金は物量・状況により変動します。まずは無料見積もりをご依頼ください。",

        // Flow
        "flow.title" to "ご利用の流れ",
        "flow.subtitle" to "お問い合わせから完了まで、安心のサポート体制",
        "flow.step1.title" to "お問い合わせ",
        "flow.step1.desc" to "メールにてお気軽にご連絡ください",
        "flow.step2.title" to "無料見積もり",
        "flow.step2.desc" to "現地を確認し、正確なお見積もりをご提示",
        "flow.step3.title" to "ご契約",
        "flow.step3.desc" to "内容にご納得いただいてからのご契約",
        "flow.step4.title" to "作業実施",
        "flow.step4.desc" to "経験豊富なスタッフが丁寧に作業",
        "flow.step5.title" to "完了報告",
        "flow.step5.desc" to "作業完了のご報告と最終確認",

        // Why choose us
        "why.title" to "選ばれる理由",
        "why.subtitle" to "LivStayJapanが多くのお客様に信頼される理由",
        "why.experience.title" to "豊富な経験",
        "why.experience.desc" to "どんなケースにも対応できる経験と知識があります。",
        "why.heart.title" to "心のこもった対応",
        "why.heart.desc" to "ご遺族のお気持ちに寄り添い、丁寧で思いやりのあるサービスを提供いたします。",
        "why.price.title" to "明瞭な料金",
        "why.price.desc" to "事前の無料見積もりで、追加料金なし。安心してご依頼いただけます。",
        "why.support.title" to "ワンストップ対応",
        "why.support.desc" to "遺品整理から法務手続きまで、提携専門家と共にトータルサポート。",

        // CTA
        "cta.title" to "まずはお気軽にご相談ください",
        "cta.subtitle" to "無料見積もり・ご相談を承っております",
        "cta.email" to "メールで相談する",

        // About page
        "about.hero.title" to "会社概要",
        "about.hero.subtitle" to "空き家・不動産活用のプロフェッショナル",
        "about.story.title" to "私たちについて",
        "about.story.p1" to "株式会社LivStay Japanは、空き家の管理・再生・活用を通じて、不動産の価値を高め、持続的に活用される仕組みを提供する会社です。",
        "about.story.p2" to "日本では空き家の増加が社会課題となる一方で、活用されずに眠っている不動産が数多く存在しています。当社はこうした不動産を単なる「管理対象」としてではなく、将来的な資産として捉え、最適な形で活用するサポートを行っています。",
        "about.story.p3" to "",
        "about.values.title" to "私たちの価値観",
        "about.values.respect.title" to "敬意",
        "about.values.respect.desc" to "故人への敬意とご遺族への思いやりを大切にしています",
        "about.values.trust.title" to "信頼",
        "about.values.trust.desc" to "透明性のある対応で、お客様の信頼にお応えします",
        "about.values.quality.title" to "品質",
        "about.values.quality.desc" to "プロフェッショナルな仕事で、高品質なサービスを提供します",
        "about.values.care.title" to "配慮",
        "about.values.care.desc" to "お客様のお気持ちに配慮した、きめ細やかな対応を心がけています",
        "about.info.title" to "会社情報",
        "about.info.name" to "会社名",
        "about.info.name.value" to "LivStayJapan",
        "about.info.service" to "事業内容",
        "about.info.service.value" to "空き家管理、不動産活用、相続・資産整理サポート、片付け支援、見守りサービス",
        "about.info.email" to "メール",
        "about.info.email.value" to "info@livstayjapan.co.jp",
        "about.info.address" to "所在地",
        "about.info.address.value" to "東京都",

        // About split (homepage)
        "about.home.title" to "Livstay Japan について",
        "about.home.desc" to "株式会社LivStay Japanは、空き家の管理・再生・活用を通じて、不動産の価値を高め、持続的に活用される仕組みを提供する会社です。",
        "about.home.cta" to "Livstay Japan について",

        // Statement section
        "statement.quote" to "オーナー様一人ひとりの\n状況に寄り添いながら、\n無理のない最適な\n不動産活用をご提案し、\n安心してご判断いただける\n環境を整えます。",
        "statement.label" to "私たちの想い",

        // Gold CTA bar
        "goldcta.text" to "まずはお気軽にご相談ください",
        "goldcta.sub" to "無料でご相談・お見積もりを承っております",
        "goldcta.btn" to "メールで問い合わせる",

        // Contact photos section
        "contact.section.title" to "お問い合わせ",
        "contact.section.desc" to "空き家管理・不動産活用・相続サポートなど、どんな些細なことでもお気軽にご連絡ください",
        "contact.section.email" to "info@livstayjapan.co.jp",
        "contact.section.cta" to "メールでのお問い合わせはこちら",

        // Qualifications section
        "qual.title" to "専門資格について",
        "qual.subtitle" to "有資格者のスタッフが安心・丁寧に対応いたします",
        "qual.1.name" to "宅地建物取引士",
        "qual.1.desc" to "国家資格を取得した不動産のプロフェッショナルが、売買・賃貸・活用をトータルサポート",
        "qual.2.name" to "管理業務主任者",
        "qual.2.desc" to "適切な管理計画の立案・実行を行う国家資格保有スタッフが担当いたします",
        "qual.3.name" to "相続診断士",
        "qual.3.desc" to "相続や資産承継に関するご相談を専門的な知識で丁寧にサポートします",
        "qual.4.name" to "空き家管理士",
        "qual.4.desc" to "全国空き家管理士協会認定の資格保有者が、適切な管理・活用をご提案します",

        // Footer
        "footer.company" to "会社情報",
        "footer.services" to "サービス",
        "footer.contact" to "お問い合わせ",
        "footer.about" to "会社概要",
        "footer.story" to "私たちについて",
        "footer.email" to "info@livstayjapan.co.jp",
        "footer.address" to "東京都",
        "footer.copyright" to "LivStayJapan. All rights reserved.",
    )

    private val en = mapOf(
        // Brand
        "brand.name" to "LivStayJapan",
        "brand.tagline" to "Compassionate estate services for families",

        // Navigation
        "nav.home" to "Home",
        "nav.services" to "Services",
        "nav.about" to "About",
        "nav.contact" to "Contact",
        "nav.consultation" to "Free Consultation",

        // Hero section
        "hero.title" to "The Best Solutions\nFor Your Property",
        "hero.subtitle" to "Vacant property management, asset settlement, real estate utilization, decluttering,\ninheritance consulting, property monitoring, buying & selling\nFeel free to reach out for any concern, big or small.",
        "hero.cta" to "Contact Us",

        // Problem section
        "problem.title" to "Are You Facing These Challenges?",
        "problem.subtitle" to "You don't have to handle it alone — reach out to us",
        "problem.1" to "Overwhelmed by a sudden inheritance and unsure where to start",
        "problem.2" to "Living far away and unable to manage a vacant property",
        "problem.3" to "Feeling emotionally burdened by sorting a loved one's belongings",
        "problem.4" to "Confused by the many procedures and paperwork required",

        // Services overview
        "services.title" to "Our Services",
        "services.subtitle" to "From vacant property management to real estate utilization — comprehensive support for you",
        "services.ihinseiri.title" to "Vacant Property Management",
        "services.ihinseiri.desc" to "Maintaining and managing your property at a reasonable, affordable price.",
        "services.akiya.title" to "Real Estate Utilization",
        "services.akiya.desc" to "Consulting tailored to your individual situation and goals.",
        "services.zaimu.title" to "Inheritance & Asset Settlement",
        "services.zaimu.desc" to "We guide you carefully through inheritance and asset management procedures.",
        "services.tokushu.title" to "Decluttering Support",
        "services.tokushu.desc" to "From sorting unwanted items to full room clearance — patient, professional support.",

        // Services detail page
        "services.page.title" to "Service Details",
        "services.page.subtitle" to "We propose the best plan tailored to your situation",

        "services.ihinseiri.detail" to "We handle everything from sorting belongings to final cleanup. Cherished items are carefully preserved and returned to the family. We also handle disposal and recycling of unwanted items.",
        "services.ihinseiri.f1" to "Sorting and organizing belongings",
        "services.ihinseiri.f2" to "Preserving cherished memories",
        "services.ihinseiri.f3" to "Disposal and recycling",
        "services.ihinseiri.f4" to "Cleaning and restoration",

        "services.akiya.detail" to "Leaving an inherited vacant house unattended can lead to deterioration and neighborhood issues. Regular inspections and management protect your valuable asset.",
        "services.akiya.f1" to "Regular inspection visits",
        "services.akiya.f2" to "Ventilation and water flow checks",
        "services.akiya.f3" to "Mail forwarding and management",
        "services.akiya.f4" to "Basic cleaning and yard maintenance",

        "services.zaimu.detail" to "Inheritance involves many different procedures and filings. We coordinate with specialists (tax accountants, judicial scriveners, lawyers) to provide comprehensive support.",
        "services.zaimu.f1" to "Inheritance filing support",
        "services.zaimu.f2" to "Name transfer procedures",
        "services.zaimu.f3" to "Specialist referrals (tax accountants, etc.)",
        "services.zaimu.f4" to "Property appraisal and sale support",

        "services.tokushu.detail" to "We handle sensitive situations such as unattended deaths or long-neglected rooms. Our certified staff perform the work safely and promptly.",
        "services.tokushu.f1" to "Specialized cleaning and deodorizing",
        "services.tokushu.f2" to "Pest control",
        "services.tokushu.f3" to "Restoration work",
        "services.tokushu.f4" to "Memorial service arrangements",

        // Pricing
        "pricing.title" to "Pricing Plans",
        "pricing.subtitle" to "Clear and transparent pricing you can trust",
        "pricing.recommended" to "Recommended",
        "pricing.basic.name" to "Basic",
        "pricing.basic.price" to "From ¥30,000",
        "pricing.basic.desc" to "Estate cleanup for 1K-1DK apartments",
        "pricing.basic.f1" to "Sorting and organizing",
        "pricing.basic.f2" to "Disposal of unwanted items",
        "pricing.basic.f3" to "Basic cleaning",
        "pricing.standard.name" to "Standard",
        "pricing.standard.price" to "From ¥80,000",
        "pricing.standard.desc" to "Estate cleanup for 2DK-3LDK apartments",
        "pricing.standard.f1" to "Sorting and organizing",
        "pricing.standard.f2" to "Disposal of unwanted items",
        "pricing.standard.f3" to "Cleaning and deodorizing",
        "pricing.standard.f4" to "Memory item preservation",
        "pricing.premium.name" to "Premium",
        "pricing.premium.price" to "From ¥150,000",
        "pricing.premium.desc" to "Estate cleanup for houses and large properties",
        "pricing.premium.f1" to "Sorting and organizing",
        "pricing.premium.f2" to "Disposal of unwanted items",
        "pricing.premium.f3" to "Cleaning, deodorizing, and restoration",
        "pricing.premium.f4" to "Memory item preservation",
        "pricing.premium.f5" to "Filing and procedure support",
        "pricing.note" to "* Prices vary based on volume and conditions. Please request a free estimate first.",

        // Flow
        "flow.title" to "How It Works",
        "flow.subtitle" to "A smooth, supportive process from start to finish",
        "flow.step1.title" to "Contact Us",
        "flow.step1.desc" to "Reach out to us by email",
        "flow.step2.title" to "Free Estimate",
        "flow.step2.desc" to "We visit the site and provide an accurate quote",
        "flow.step3.title" to "Agreement",
        "flow.step3.desc" to "Contract only after your full approval",
        "flow.step4.title" to "Work Begins",
        "flow.step4.desc" to "Our experienced staff carry out the work with care",
        "flow.step5.title" to "Completion",
        "flow.step5.desc" to "Final report and confirmation",

        // Why choose us
        "why.title" to "Why Choose Us",
        "why.subtitle" to "Trusted by families across Japan",
        "why.experience.title" to "Extensive Experience",
        "why.experience.desc" to "We have the expertise to handle any situation with care and professionalism.",
        "why.heart.title" to "Compassionate Service",
        "why.heart.desc" to "We approach every case with empathy and respect for the bereaved family.",
        "why.price.title" to "Transparent Pricing",
        "why.price.desc" to "Free estimates with no hidden fees. You can trust our pricing.",
        "why.support.title" to "One-Stop Solution",
        "why.support.desc" to "From cleanup to legal procedures, we coordinate with specialists for complete support.",

        // CTA
        "cta.title" to "Get in Touch",
        "cta.subtitle" to "Free estimates and consultations available",
        "cta.email" to "Email Us",

        // About page
        "about.hero.title" to "About Us",
        "about.hero.subtitle" to "Specialists in vacant property management and real estate utilization",
        "about.story.title" to "About LivStay Japan",
        "about.story.p1" to "LivStay Japan Co., Ltd. provides a sustainable system for managing, revitalizing, and utilizing vacant properties — increasing their real estate value and keeping them productive.",
        "about.story.p2" to "While vacant houses have become a growing social issue in Japan, many properties remain dormant and underutilized. Rather than treating these simply as 'properties to manage', we see them as future assets and support their optimal utilization.",
        "about.story.p3" to "",
        "about.values.title" to "Our Values",
        "about.values.respect.title" to "Respect",
        "about.values.respect.desc" to "We honor the deceased and show compassion to their families",
        "about.values.trust.title" to "Trust",
        "about.values.trust.desc" to "We earn trust through transparent and honest communication",
        "about.values.quality.title" to "Quality",
        "about.values.quality.desc" to "We deliver professional, high-quality service every time",
        "about.values.care.title" to "Care",
        "about.values.care.desc" to "We provide thoughtful, attentive service with sensitivity",
        "about.info.title" to "Company Information",
        "about.info.name" to "Company Name",
        "about.info.name.value" to "LivStayJapan",
        "about.info.service" to "Services",
        "about.info.service.value" to "Vacant property management, real estate utilization, inheritance & asset settlement, decluttering support, property monitoring",
        "about.info.email" to "Email",
        "about.info.email.value" to "info@livstayjapan.co.jp",
        "about.info.address" to "Location",
        "about.info.address.value" to "Tokyo, Japan",

        // About split (homepage)
        "about.home.title" to "About Livstay Japan",
        "about.home.desc" to "LivStay Japan Co., Ltd. provides a sustainable system for managing, revitalizing, and utilizing vacant properties to increase their real estate value.",
        "about.home.cta" to "About Livstay Japan",

        // Qualifications section
        "qual.title" to "Our Professional Qualifications",
        "qual.subtitle" to "Our certified staff ensures a safe and professional experience",
        "qual.1.name" to "Licensed Real Estate Agent",
        "qual.1.desc" to "Nationally licensed professionals providing total support for buying, selling, and property utilization",
        "qual.2.name" to "Property Management Supervisor",
        "qual.2.desc" to "State-licensed supervisors who develop and execute proper property management plans",
        "qual.3.name" to "Inheritance Consultant",
        "qual.3.desc" to "Expert guidance on inheritance and asset succession with specialized knowledge",
        "qual.4.name" to "Vacant Property Manager",
        "qual.4.desc" to "Certified by the national vacant property management association — proposing the best solutions",

        // Statement section
        "statement.quote" to "We stand beside each property\nowner's unique situation,\nproposing the most fitting\nreal estate solution —\nso you can make decisions\nwith complete peace of mind.",
        "statement.label" to "Our Mission",

        // Gold CTA bar
        "goldcta.text" to "Feel free to reach out anytime",
        "goldcta.sub" to "Free consultations and estimates available",
        "goldcta.btn" to "Contact Us by Email",

        // Contact section
        "contact.section.title" to "Contact Us",
        "contact.section.desc" to "Whether it's estate cleanup, vacant property, or real estate — feel free to reach out for a free consultation",
        "contact.section.email" to "info@livstayjapan.co.jp",
        "contact.section.cta" to "Send Us an Email",

        // Footer
        "footer.company" to "Company",
        "footer.services" to "Services",
        "footer.contact" to "Contact",
        "footer.about" to "About Us",
        "footer.story" to "Our Story",
        "footer.email" to "info@livstayjapan.co.jp",
        "footer.address" to "Tokyo, Japan",
        "footer.copyright" to "LivStayJapan. All rights reserved.",
    )
}
